import DataTable from "react-data-table-component";

const Table = ({
  title,
  columns,
  data,
  pagination = false,
  defaultSortField,
  defaultSortAsc = true,
  onSelectedRowsChange,
  conditionalRowStyles,
  subHeader,
  subHeaderComponent,
  paginationPerPage,
  onChangeRowsPerPage,
  onChangePage,
  paginationRowsPerPageOptions,
  currentPage,
  totalRowCount,
  paginationServer = true,
  onSort,
  serverSideSort = false,
  NoRecordsText = "",
  sortColumn,
  sortDirection,
  fixedHeader = false,
  fixedHeaderScrollHeight = "300px",
  showSeachField = true,
  handleSearchChange,
  handleSearchSubmit,
}) => {
  return (
    <form
    // onSubmit={(e) => {
    //   handleSearchSubmit(e);
    // }}
    >
      {/* {showSeachField && (
        <div className="mb-3 d-flex justify-content-end align-items-center">
          <div className="w-25 d-flex justify-content-center align-items-center search-input-field">
            <input
              className={`fw-normal form-control fs-5 p-0 border-0 outline-0 shadow-none`}
              placeholder="Search..."
              onChange={(e) => {
                handleSearchChange(e);
              }}
            />
            <i
              class="ms-2 fa fa-search cursor-pointer"
              aria-hidden="true"
              onClick={(e) => {
                handleSearchSubmit(e);
              }}
            ></i>
          </div>
        </div>
      )} */}
      <DataTable
        title={title}
        columns={columns}
        data={data}
        pagination={pagination}
        paginationPerPage={paginationPerPage}
        paginationRowsPerPageOptions={
          paginationRowsPerPageOptions || [10, 25, 50, 100, 200]
        }
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationTotalRows={totalRowCount}
        paginationDefaultPage={currentPage}
        paginationServer={paginationServer}
        onSort={onSort}
        sortServer={serverSideSort}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        defaultSortField={sortColumn}
        defaultSortAsc={sortDirection === "asc"}
        noDataComponent={
          <b className="table-no-data-text mt-5 fs-4 mb-5">
            {NoRecordsText || "No data found"}
          </b>
        }
        className={
          data?.length === 0 || data?.length === undefined
            ? "no-data-table border-radius-none font-size-14"
            : "data-table border-radius-none font-size-14"
        }
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
      />
      {pagination && data?.length > 0 && (
        <div className="pagination-postion">
          <p className="fs-5 mb-3 totalRecords">
            Total No.of Records: {totalRowCount}
          </p>
        </div>
      )}
    </form>
  );
};

export default Table;
